import React , { Component, useState,useEffect } from 'react';
import Content from '../Content/content';
import {isPCUserDeviceType} from '../../utils/GetUserDeviceType';


const Home=(props)=>{

    let userAgent =navigator.userAgent;
    let isPC=isPCUserDeviceType(userAgent);
    // 如果用户设备不是PC，那么就跳到移动端页面
    if(!isPC){
        window.location.href= 'http://www.bjjwtd.com/app';
    }


    return(
        <div style={{width: '100%'}}>
            <Content />
        </div>
    );
}

export default Home;
